import PubSub from "./PubSub";

/**
 * A global instance of PubSub that can be imported by any class in order to publish/subscribe
 * messages to any other class
 * @type {PubSub}
 *
 * @example
 * // CLASS A
 * import pubSub from "path/to/this/pubSubGlobal.js"
 *
 * pubSub.publish("ClassA.somethingHappened", someObject);
 *
 *
 * // CLASS B
 * import pubSub from "path/to/this/pubSubGlobal.js"
 *
 * function onSomethingHappened (params) { ... }
 * pubSub.subscribe(onSomethingHappened, "ClassA.somethingHappened");
 */
const globalPubSubInstance = new PubSub();

export default globalPubSubInstance;
